class StickyProgressBar extends HTMLElement {
  constructor() {
    super();
    
    // Add cart update subscriber
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      this.checkGiftThreshold();
    });
  }

  // Add cleanup
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  async checkGiftThreshold() {
    const progressBar = this.querySelector('.sticky-progress');
    if (!progressBar) return false;
    
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Filter out gift item and count remaining items
      const cartCount = cart.items.reduce((count, item) => {
        return item.variant_id === 49936273146182 ? count : count + item.quantity;
      }, 0);
      
      // Update progress bar data attribute with filtered count
      progressBar.dataset.cartCount = cartCount;
      
      return cartCount >= 3;
    } catch (error) {
      console.error('Error checking cart:', error);
      return false;
    }
  }
}

customElements.define('sticky-progress-bar', StickyProgressBar); 